module.exports = __webpack_public_path__ + "startpage-746fed5a/template-1-52ec88d6a3ca88343e9f65c321dd5c7a.jpg";